module.exports = __webpack_public_path__ + "static/img/PermissionDenied.3d5d73f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/PermissionDenied.png
// module id = CKrt
// module chunks = 1